<template>
  <div>
    <b-row>
      <b-col md="10" class="settings-panel">
        <div class="card">
          <div class="card-header text-center">
            Cron Settings
          </div>
          <b-row>
            <b-col class="settings-panel-body cronsettings">
              <div class="card-block">
                <b-form>
                  <p class="helper-text py-4 m-100">
                    <info-round-icon class="icon-default inforound"></info-round-icon>
                    Set anyone of the following cron jobs</p>
                  <legend class="m-100">Set Your Own Cron Job (recommended)</legend>

                  <b-form-group class="px-3 m-100" id="exampleInputGroup1" label="Use This Cron Job Command To Set At CPanel" label-for="cron" description="Set the cron to run every 20 min. For scheduled multi-call backups, set the cron to run every 5 min.">
                    <b-row>
                      <b-col class="cron-input-cont">
                        <b-form-input id="cron" type="text" v-model="appInfo.APP_PHP_CRON_CMD" required></b-form-input>
                        <b-btn variant="outline-secondary" class="input-inline-btn" v-clipboard="appInfo.APP_PHP_CRON_CMD" @success="handleSuccess" @error="handleError">
                          <span v-if="!copySuccess">Copy</span>
                          <span v-else>Copied :)</span>
                        </b-btn>
                      </b-col>
                    </b-row>
                    <p class="helper-note py-2">
                      <span v-if="cronSettings.getRealSystemCronRunningFrequencyV3>0">
                        <success-filled-icon class="icon-default success"></success-filled-icon>
                        This cron is running every {{cronSettings.getRealSystemCronRunningFrequencyV3}} min.
                      </span>
                      <span v-else>
                        <error-filled-icon class="icon-default error"></error-filled-icon>
                        This cron is not running.
                      </span>

                    </p>
                  </b-form-group>
                  <hr>
                  <legend class="m-100">Use EasyCron Service</legend>
                  <b-form-group class="px-3 m-100" id="exampleInputGroup1" description="The Cron job will be created automatically once you click on Activate. You need not create it manually at easycron.com">
                    <label>
                      Connect Your EasyCron Account
                      <a class="helper-links" target="_blank" :href="appInfo.SUPPORT_URL+'support/solutions/articles/212264'+appInfo.GA_HELP_TRACKING">See Instructions</a>
                    </label>
                    <div class="d-flex">
                      <b-form-input id="cron" class="col-10" type="text" v-model="cronSettings['manageEasyCron::getTokenFromDB']" required>
                      </b-form-input>

                      <b-btn variant="outline-secondary" style="    margin-left: 10px;" v-if="!cronSettings['manageEasyCron::isActive']" size="sm" @click="saveEasyCron(1)">Activate</b-btn>
                      <b-btn variant="outline-secondary" style="    margin-left: 10px;" v-if="cronSettings['manageEasyCron::isActive']" size="sm" @click="deactivate(0)">Deactivate</b-btn>
                    </div>
                    <p class="error-message" v-if="errorMessage">
                      {{errorMessage}}
                    </p>
                    <p class="helper-note py-2">
                      <span v-if="cronSettings['manageEasyCron::isActive']">
                        <success-filled-icon class="icon-default success"></success-filled-icon>
                        Easy cron is active
                      </span>
                      <span v-else>
                        <error-filled-icon class="icon-default error"></error-filled-icon>
                        Easy cron is not active
                      </span>
                    </p>
                  </b-form-group>
                </b-form>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import InfoRoundIcon from '../../assets/inforound.svg';
import SuccessFilledIcon from '../../assets/successfilled.svg';
import ErrorFilledIcon from '../../assets/errorfilled.svg';
import VueClipboards from 'vue-clipboards';
Vue.use(VueClipboards);
export default {
  name: 'cronsettings',
  props: ['settings'],
  components: {
    InfoRoundIcon,
    SuccessFilledIcon,
    ErrorFilledIcon
  },
  created() {
    this.loadCronSettings();
    this.appInfo = this.$store.getters.getAppInfo;
  },
  data() {
    return {
      showChangePassword: false,
      copySuccess: false,
      form: {},
      appInfo: {},
      errorMessage: null,
      cronSettings: {}
    };
  },
  methods: {
    loadCronSettings() {
      let payload = {
        requiredData: {
          'manageEasyCron::isActive': 1,
          'manageEasyCron::getTokenFromDB': 1,
          getRealSystemCronRunningFrequencyV3: 1,
          'Manage_IWP_Cron::isActive': 1
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.cronSettings = response.data;
      });
    },
    handleSuccess() {
      
      this.copySuccess = true;
    },
    handleError() {
      
    },
    deactivate() {
      let payload = {
        requiredData: {
          'manageEasyCron::deactivate': 1
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        let easyCronResponse = response.data['manageEasyCron::deactivate'];
        if (easyCronResponse && easyCronResponse.status == 'error') {
          this.errorMessage = easyCronResponse.error.message;
          setTimeout(() => {
            this.errorMessage = null;
          }, 3000);
        } else {
          this.cronSettings['manageEasyCron::isActive'] = 0;
        }
      });
    },
    saveEasyCron(value) {
      let payload = {};
      let requiredData = {};
      requiredData['manageEasyCron::activate'] = {
        token: this.cronSettings['manageEasyCron::getTokenFromDB']
      };
      requiredData['manageEasyCron::isActive'] = value;
      requiredData['manageEasyCron::getTokenFromDB'] = 1;
      payload['requiredData'] = requiredData;
      this.$store.dispatch('sendAction', payload).then(response => {
        this.cronSettings = response.data;
        let easyCronResponse = response.data['manageEasyCron::activate'];
        if (easyCronResponse && easyCronResponse.status == 'error') {
          this.errorMessage = easyCronResponse.error.message;
          setTimeout(() => {
            this.errorMessage = null;
          }, 3000);
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Settings/CronSettings.vue